export default "__VITE_ASSET__V1R96HTo__"